<body>
    <div class="main-nav">
        <div class="row">
            <div class="col-7">
                <img style="margin-bottom:20px;" height="35px" src="assets/img/logo/digimet-logo.png" alt="digimet-logo">
                <a class="navbar-brand" href="#">
                    <span class="nav-brand-l konkhmer">DIGIMET</span>
                    <span class="nav-brand-m konkhmer">Connect</span>
                </a>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="overlay" *ngIf="loading">
            <div class="snippet login-load">
                <div class="stage">
                    <div style="margin:10px 0 0 20px;padding-left: 10px;">
                        <div class="dot-pulse"></div>
                    </div>
                    <div style="margin: 70px 0 0 -45px;">{{japaneseLabels["loading_text"]}}</div>
                </div>
            </div>
            </div>
            <!-- 1st reset form for sending mail and pin -->
            <form class="login-form">
                <div class="text-center mt-5">
                    <h4 class="konkhmer">アカウント認証が必要です</h4>
                </div>
                <div class="form-group mt-4">
                    <label style="font-size: 12px;">アカウントID</label>
                    <input style="border-radius: 0;color: #4F4F4F;" type="text" class="form-control" (input)="ChangeToLower()" [(ngModel)]="account_login_id" name="loginId" [readonly]="sendMail" required>
                    <!-- Error Message -->
                    <div style="height: 10px;">
                        <span *ngIf="submitError" class="error">{{errorTexts["account_id_not_exist"]}}</span>
                    </div>
                </div>
                <div class="text-center mt-3">
                    <button type="submit" class="btn login-btn" (click)="accountLoginId()" [disabled]="sendMail">認証コードを送信</button>
                </div>
                <div class="form-group mt-4">
                    <label style="font-size: 12px; ">認証コード</label>
                    <input style="border-radius: 0;color: #4F4F4F;" type="password" class="form-control reset-btn" placeholder="" [(ngModel)]="password" name="password"  [disabled]="!sendMail">
                </div>
                <!-- Error Message -->
                <div style="margin-top: 5px;">
                  <span *ngIf="!passwordError">認証コードはメールアドレス宛に送付されます。</span>
                  <span *ngIf="passwordError" class="error">{{errorTexts["auth_code_does_not_match"]}}</span>
                </div>
                <div class="text-center mt-3">
                    <button type="submit" class="btn login-btn reset-btn" (click)="resetPassword()" [disabled]="!sendMail">設定完了する</button>
                </div>
            </form>
        </div>
    </div>
</body>
